(() => {
  const cache = new Map();
  const validHandle = /^[a-z0-9][a-z0-9-]*$/;
  const marketPrefix = () =>
    `${window.Shopify?.routes?.root || "/"}:${window.Shopify?.currency?.active || ""}:${window.Shopify?.country || ""}:`;
  const nativeMarket = marketPrefix();
  const nativeExpires = Date.now() + 60000;
  function reuseNativeCards() {
    if (marketPrefix() !== nativeMarket || Date.now() >= nativeExpires) return;
    for (const source of document.querySelectorAll("#ProductsList > [data-rival-native-card]")) {
      const handle = source.dataset.rivalNativeCard;
      if (!validHandle.test(handle || "")) continue;
      const node = source.cloneNode(true);
      // Match the result-card template: no quick add, quick view or compare.
      // Never touch the original grid, which remains the service-error fallback.
      node.querySelectorAll("script, quick-view-modal, compare-checkbox, .product-card__quickview, .product-card__main-actions, .product-card__list-actions-main")
        .forEach((item) => item.remove());
      const link = node.querySelector(".product-card__title a[href]");
      if (!link || !node.querySelector(".f-price") || node.querySelector("[id], [aria-controls]")) continue;
      const url = new URL(link.getAttribute("href"), location.origin);
      if (url.origin !== location.origin || !url.pathname.endsWith(`/products/${handle}`) || url.searchParams.has("variant")) continue;
      node.querySelectorAll("motion-element").forEach((item) => item.removeAttribute("style"));
      node.removeAttribute("data-rival-native-card");
      node.dataset.rivalThemeCard = handle;
      cache.set(nativeMarket + handle, { html: node.outerHTML, expires: nativeExpires });
    }
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", reuseNativeCards, { once: true });
  else reuseNativeCards();
  const variantId = (product) =>
    String(product.variantShopifyId || "").match(
      /^gid:\/\/shopify\/ProductVariant\/(\d+)$/,
    )?.[1];
  window.RivalThemeCards = {
    offerBrowse(container, onBrowse) {
      const button = document.createElement("button");
      button.type = "button";
      button.textContent =
        this.text?.("browse", "Browse all products — vehicle filtering off") ||
        "Browse all products — vehicle filtering off";
      button.addEventListener("click", onBrowse);
      container.append(button);
    },
    styleGrid(grid) {
      const native = document.querySelector("#ProductsList");
      grid.className = native?.className || "products-list f-grid";
      grid.classList.add("rival-theme-results-grid");
      if (native) grid.style.cssText = native.style.cssText;
    },
    async renderPage(products, signal) {
      if (
        products.length > 100 ||
        products.some((p) => !validHandle.test(p.handle || ""))
      )
        throw new Error("Product information is unavailable. Please retry.");
      const locale = window.Shopify?.routes?.root || "/";
      const cachePrefix = marketPrefix();
      for (const [key, entry] of cache) {
        if (entry.expires <= Date.now()) cache.delete(key);
      }
      const missing = [
        ...new Set(products.filter((p) => !variantId(p)).map((p) => p.handle)),
      ].filter((handle) => !cache.has(cachePrefix + handle));
      const batches = Array.from(
        { length: Math.ceil(missing.length / 12) },
        (_, i) => missing.slice(i * 12, i * 12 + 12),
      );
      let batchPosition = 0;
      await Promise.all(
        Array.from({ length: Math.min(2, batches.length) }, async () => {
          while (batchPosition < batches.length && !signal.aborted) {
            const handles = batches[batchPosition++];
            const url = new URL(`${locale}search`, location.origin);
            url.searchParams.set("section_id", "rival-fitment-cards");
            url.searchParams.set("type", "product");
            url.searchParams.set("q", `rival-fitment:${handles.join(",")}`);
            const response = await fetch(url.href, {
              signal,
              headers: { Accept: "text/html" },
            });
            if (!response.ok)
              throw new Error(
                "Product information is unavailable. Please retry.",
              );
            const document = new DOMParser().parseFromString(
              await response.text(),
              "text/html",
            );
            for (const node of document.querySelectorAll(
              "[data-rival-theme-card]",
            )) {
              const handle = node.getAttribute("data-rival-theme-card");
              if (!handles.includes(handle)) continue;
              node
                .querySelectorAll("script")
                .forEach((script) => script.remove());
              cache.set(cachePrefix + handle, {
                html: node.outerHTML,
                expires: Date.now() + 60000,
              });
            }
          }
        }),
      );
      // Only the selected result page is hydrated. Variant-specific results must
      // use the matching option's live Liquid price, never a cheaper wrong option.
      const variants = [
        ...new Map(
          products
            .filter(variantId)
            .map((p) => [`${p.handle}:${variantId(p)}`, p]),
        ).entries(),
      ].filter(([key]) => !cache.has(cachePrefix + key));
      let position = 0;
      await Promise.all(
        Array.from({ length: Math.min(4, variants.length) }, async () => {
          while (position < variants.length && !signal.aborted) {
            const [key, product] = variants[position++];
            const url = new URL(
              `${locale}products/${product.handle}`,
              location.origin,
            );
            url.searchParams.set("variant", variantId(product));
            url.searchParams.set("section_id", "rival-fitment-cards");
            const response = await fetch(url, {
              signal,
              headers: { Accept: "text/html" },
            });
            if (!response.ok)
              throw new Error(
                "Product information is unavailable. Please retry.",
              );
            const parsed = new DOMParser().parseFromString(
              await response.text(),
              "text/html",
            );
            const node = parsed.querySelector("[data-rival-theme-card]");
            const price = node
              ?.querySelector("template[data-rival-variant-price]")
              ?.content.querySelector(".f-price");
            const target = node?.querySelector(".f-price");
            if (
              node?.dataset.rivalThemeCard !== product.handle ||
              node?.dataset.rivalVariant !== variantId(product) ||
              !price ||
              !target
            )
              throw new Error(
                "The theme's matching-option card needs updating. Please retry or browse without vehicle filtering.",
              );
            target.replaceWith(price.cloneNode(true));
            node
              .querySelectorAll(
                "script, template[data-rival-variant-price], quick-view-modal",
              )
              .forEach((item) => item.remove());
            cache.set(cachePrefix + key, {
              html: node.outerHTML,
              expires: Date.now() + 60000,
            });
          }
        }),
      );
      if (signal.aborted) throw new DOMException("Aborted", "AbortError");
      const copy = (key, fallback) => this.text?.(key, fallback) || fallback;
      const checkLabel = copy("conditional", "Check fitment");
      const universalLabel = copy("universal", "Universal");
      const unknownLabel = copy("unconfirmed", "Fitment not confirmed");
      const notFitLabel = copy("notFit", "Does not fit your vehicle");
      const result = products.map((product) => {
        const variant = variantId(product);
        const html = cache.get(
          cachePrefix + product.handle + (variant ? `:${variant}` : ""),
        )?.html;
        if (!html)
          throw new Error(
            "Catalogue availability changed. Please refresh and retry.",
          );
        const node = new DOMParser().parseFromString(html, "text/html").body
          .firstElementChild;
        node.dataset.rivalExactProduct = product.productId;
        if (variant) {
          for (const link of node.querySelectorAll("a[href]")) {
            const url = new URL(link.getAttribute("href"), location.origin);
            if (
              url.origin === location.origin &&
              url.pathname.endsWith(`/products/${product.handle}`)
            ) {
              url.searchParams.set("variant", variant);
              link.setAttribute("href", url.pathname + url.search + url.hash);
            }
          }
        }
        // The selected vehicle and result count already confirm the browsing scope.
        // Keep only exceptions on collection cards; full confirmation stays on PDPs.
        if (product.result === "CONFIRMED_FIT" || product.result === "BROWSE")
          return node;
        const status = document.createElement("a");
        status.className = "rival-theme-fitment-status";
        status.textContent =
          product.result === "CHECK_SPECIFICATION"
            ? checkLabel
            : product.result === "UNIVERSAL_FIT"
              ? universalLabel
              : product.result === "CONFIRMED_NOT_FIT"
                ? notFitLabel
                : unknownLabel;
        const target = new URL(
          `${locale}products/${product.handle}`,
          location.origin,
        );
        if (variant) target.searchParams.set("variant", variant);
        status.href = target.pathname + target.search;
        node.append(status);
        // The product page owns the full compatibility conditions and warnings.
        // Conditional results stay conditional; this only shortens their card UI.
        return node;
      });
      if (cache.size > 120) cache.clear();
      return result;
    },
  };
})();

/* RIVAL: vehicle controls adapter; retain original controls and their handlers. */
;(() => {
  const svgNS = 'http://www.w3.org/2000/svg';
  function makeIcon(className, pathData) {
    const icon = document.createElementNS(svgNS, 'svg');
    for (const [key, value] of Object.entries({ class: className, viewBox: '0 0 24 24', 'aria-hidden': 'true', focusable: 'false', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.8', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' })) icon.setAttribute(key, value);
    const path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', pathData);
    icon.append(path);
    return icon;
  }
  function label(text) {
    const node = document.createElement('span');
    node.className = 'rival-control-label';
    node.textContent = text;
    return node;
  }
  function decorateControls() {
    document.querySelectorAll('[data-rival-vehicle-finder]').forEach(root => {
      root.classList.add('rival-controls-ready');
      const registration = root.querySelector('.rival-registration input');
      if (registration) registration.setAttribute('placeholder', 'YOUR REG');
      const submit = root.querySelector('[data-rival-registration-submit]:not([data-rival-control-ready])');
      if (submit) {
        submit.dataset.rivalControlReady = 'true';
        const go = document.createElement('span');
        go.textContent = 'GO';
        submit.replaceChildren(go);
      }
      const manual = root.querySelector('[data-rival-mode="manual"]:not([data-rival-control-ready])');
      if (manual) {
        manual.dataset.rivalControlReady = 'true';
        manual.setAttribute('aria-label', 'Choose vehicle manually');
        manual.setAttribute('title', 'Choose vehicle manually');
        const chevron = manual.querySelector('.rival-manual-chevron');
        manual.replaceChildren(makeIcon('rival-control-icon', 'M4 10l2-6h10l2 6M3 10h15M7 17H5v2H2v-6l1-3M5 13h2M20 15a4 4 0 1 1-8 0 4 4 0 1 1 8 0Zm-1 3 3 3'), label('Choose manually'));
        if (chevron) manual.append(chevron);
      }
      const garage = root.querySelector('[data-rival-saved-garage-toggle]:not([data-rival-control-ready])');
      if (garage) {
        garage.dataset.rivalControlReady = 'true';
        garage.setAttribute('aria-label', 'My Garage');
        garage.setAttribute('title', 'My Garage');
        const count = garage.querySelector('[data-rival-saved-garage-count]');
        garage.replaceChildren(makeIcon('rival-control-icon', 'M3 21V8l9-5 9 5v13M7 21V11h10v10M7 15h10M7 18h10'), label('My Garage'));
        if (count) garage.append(count);
      }
      const closer = root.querySelector('[data-rival-dialog-close]:not([data-rival-control-ready])');
      if (closer) {
        closer.dataset.rivalControlReady = 'true';
        closer.setAttribute('aria-label', 'Close vehicle picker');
        closer.setAttribute('title', 'Close');
        closer.replaceChildren(makeIcon('rival-control-icon', 'm6 6 12 12M18 6 6 18'));
      }
      const changer = root.querySelector('[data-rival-change]:not([data-rival-control-ready])');
      if (changer) {
        changer.dataset.rivalControlReady = 'true';
        changer.setAttribute('aria-label', 'Change vehicle');
        changer.setAttribute('title', 'Change vehicle');
        const changeLabel = document.createElement('span');
        changeLabel.className = 'rival-change-label';
        changeLabel.textContent = 'Change';
        changer.replaceChildren(makeIcon('rival-change-icon', 'M4 7h15m-4-4 4 4-4 4M20 17H5m4-4-4 4 4 4'), changeLabel);
      }
      const content = root.querySelector('[data-rival-dialog-content]');
      if (content && !content.querySelector('.rival-picker-intro')) {
        const intro = document.createElement('p');
        intro.className = 'rival-picker-intro';
        intro.textContent = 'Use a registration, choose manually or pick from your garage.';
        content.prepend(intro);
      }
    });
  }
  decorateControls();
  for (const event of ['DOMContentLoaded', 'rival:finder-ready', 'shopify:section:load']) document.addEventListener(event, decorateControls);
})();
/* END RIVAL: vehicle controls adapter. */


/* RIVAL: responsive header Account and Garage entry; preserve native app handlers. */
;(() => {
  const mobile = window.matchMedia('(max-width: 1023px)');
  let state;

  function move(node, parent, before = null) {
    if (!node || !parent || (node.parentNode === parent && node.nextSibling === before)) return;
    // Preserve custom-element state where supported, particularly Shopify Account.
    if (parent.moveBefore && node.isConnected) parent.moveBefore(node, before);
    else parent.insertBefore(node, before);
  }

  function place() {
    if (!state?.header.isConnected) return;
    const { header, account, accountHome, left, right, nav, button } = state;
    if (mobile.matches) {
      move(account, left);
      move(button, right, right.querySelector('.cart-drawer-button'));
    } else {
      if (accountHome?.isConnected) move(account, accountHome.parentNode, accountHome.nextSibling);
      move(button, nav);
    }
    header.classList.add('rival-header-garage-ready');
  }

  function mount() {
    const header = document.querySelector('header[data-section-id]');
    const root = document.querySelector('[data-rival-vehicle-finder][data-indicator="true"][data-initialized="true"]');
    const left = header?.querySelector('.header__icons--left .header__buttons');
    const right = header?.querySelector('.header__icons--right .header__buttons');
    const nav = header?.querySelector('.header__navigation');
    const trigger = root?.querySelector('[data-rival-saved-garage-toggle]');
    const dialog = root?.querySelector('[data-rival-vehicle-dialog]');
    if (!left || !right || !nav || !trigger || !dialog) return;
    if (state?.header === header && state?.root === root) { place(); return; }

    if (state) {
      state.observer.disconnect();
      state.button.remove();
      state.root.classList.remove('rival-garage-in-header');
      if (state.accountHome?.isConnected) {
        move(state.account, state.accountHome.parentNode, state.accountHome.nextSibling);
        state.accountHome.remove();
      }
    }
    const account = header.querySelector('.header__account');
    const accountHome = account ? document.createComment('RIVAL: desktop account position') : null;
    if (accountHome) account.before(accountHome);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rival-header-garage font-navigation';
    button.dataset.rivalHeaderGarage = '';
    const title = root.dataset.garageTitle || 'My Garage';
    button.setAttribute('aria-label', title);
    button.setAttribute('title', title);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', dialog.id);
    const icon = trigger.querySelector('svg')?.cloneNode(true);
    if (icon) button.append(icon);
    const label = document.createElement('span');
    label.className = 'rival-header-garage__label';
    label.textContent = title;
    const count = document.createElement('span');
    count.className = 'rival-header-garage__count';
    count.setAttribute('aria-hidden', 'true');
    button.append(label, count);
    button.addEventListener('click', () => {
      // The app records activeElement so Escape/Close returns to this header button.
      button.focus({ preventScroll: true });
      trigger.click();
    });
    const sourceCount = root.querySelector('[data-rival-saved-garage-count]');
    function sync() {
      const text = sourceCount?.textContent?.trim() || '';
      count.textContent = text;
      count.dataset.count = text.replace(/[()]/g, '').trim();
      count.hidden = !text || text === '(0)';
      button.disabled = trigger.disabled;
      button.setAttribute('aria-expanded', String(root.dataset.openPanel === 'garage'));
    }
    const observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, attributeFilter: ['data-open-panel'] });
    observer.observe(trigger, { attributes: true, attributeFilter: ['disabled'] });
    if (sourceCount) observer.observe(sourceCount, { childList: true, characterData: true, subtree: true });
    state = { header, root, left, right, nav, account, accountHome, button, observer };
    root.classList.add('rival-garage-in-header');
    sync();
    place();
  }
  mount();
  mobile.addEventListener('change', place);
  for (const event of ['DOMContentLoaded', 'rival:finder-ready', 'shopify:section:load']) document.addEventListener(event, mount);
})();
/* END RIVAL: responsive header Account and Garage entry. */


/* RIVAL: manual selection badges and consistent vehicle action controls. */
;(() => {
  const observed = new WeakSet();
  const paths = {
    parts: 'm12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Zm0 9 8-4.5M12 12 4 7.5M12 12v9M8 5.25l8 4.5',
    details: 'M12 8h.01M11 12h1v5M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
    change: 'M4 7h15m-4-4 4 4-4 4M20 17H5m4-4-4 4 4 4',
    garage: 'M3 21V8l9-5 9 5v13M7 21V11h10v10M7 15h10M7 18h10',
    remove: 'M5 12h14',
  };
  function icon(kind) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [key, value] of Object.entries({ class: 'rival-action-icon', viewBox: '0 0 24 24', 'aria-hidden': 'true', focusable: 'false', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.8', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' })) svg.setAttribute(key, value);
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', paths[kind]);
    svg.append(path);
    return svg;
  }
  function decorate(button, kind) {
    if (!button || button.dataset.rivalActionReady) return;
    button.dataset.rivalActionReady = 'true';
    button.classList.add('rival-action-control');
    // Keep the app-owned label/count nodes and the original element/listeners.
    button.querySelector('.rival-parts-arrow')?.remove();
    if (!button.querySelector('svg')) button.prepend(icon(kind));
  }
  function enhanceSummary(identity, label) {
    // Display-only copies: keep the app's label/spec nodes and vehicle data intact.
    const fullName = label.textContent.trim();
    if (!fullName) return;
    const year = fullName.match(/\s*\((\d{4}[^)]*)\)\s*$/);
    const name = year ? fullName.slice(0, year.index).trim() : fullName;
    const knownSpecs = identity.querySelector('[data-rival-identity-specs]')?.textContent.trim() || '';
    const details = identity.closest('[data-rival-vehicle-finder]');
    const spec = key => details?.querySelector(`[data-rival-spec-key="${key}"] dd`)?.textContent.trim() || '';
    const items = [
      ['year', year?.[1] || ''],
      ['engine', knownSpecs.replace(/\s*·\s*/g, ' ')],
      ['chassis', spec('chassis')],
      ['power', spec('power').replace(/\s*\([^)]*\)\s*$/, '')]
    ].filter(([, value]) => value);
    let nameNode = identity.querySelector('.rival-summary-name');
    if (!nameNode) {
      nameNode = document.createElement('strong');
      nameNode.className = 'rival-summary-name';
      identity.append(nameNode);
    }
    if (nameNode.textContent !== name) nameNode.textContent = name;
    let specsNode = identity.querySelector('.rival-summary-specs');
    if (!specsNode) {
      specsNode = document.createElement('span');
      specsNode.className = 'rival-summary-specs';
      identity.append(specsNode);
    }
    const signature = JSON.stringify(items);
    if (specsNode.dataset.signature !== signature) {
      specsNode.replaceChildren(...items.map(([key, value]) => {
        const node = document.createElement('span');
        node.className = `rival-summary-spec rival-summary-spec--${key}`;
        node.textContent = value;
        return node;
      }));
      specsNode.dataset.signature = signature;
      specsNode.title = items.map(([, value]) => value).join(' · ');
    }
    specsNode.hidden = !items.length;
    identity.classList.add('rival-summary-ready');
  }
  function enhance(root) {
    root.classList.add('rival-actions-polished');
    for (const label of root.querySelectorAll('[data-rival-active-label], [data-rival-details-label], [data-rival-garage-label]')) {
      const identity = label.closest('.rival-vehicle-identity');
      if (!identity) continue;
      if (label.hasAttribute('data-rival-active-label')) enhanceSummary(identity, label);
      const manual = identity.dataset.hasPlate === 'false' && Boolean(label.textContent.trim());
      identity.classList.toggle('rival-identity-manual', manual);
      let badge = identity.querySelector('.rival-manual-plate');
      if (manual && !badge) {
        badge = document.createElement('span');
        badge.className = 'rival-vehicle-plate rival-manual-plate';
        badge.textContent = 'MANUAL';
        badge.setAttribute('aria-label', 'Vehicle selected manually');
        identity.prepend(badge);
      }
      // A separate display badge: never put MANUAL into registration data/input.
      if (badge && badge.hidden === manual) badge.hidden = !manual;
    }
    root.querySelectorAll('[data-rival-shop-parts]').forEach(button => decorate(button, 'parts'));
    decorate(root.querySelector('[data-rival-details-toggle]'), 'details');
    decorate(root.querySelector('[data-rival-change]'), 'change');
    decorate(root.querySelector('[data-rival-details-change]'), 'change');
    decorate(root.querySelector('[data-rival-garage-toggle]'), 'garage');
    decorate(root.querySelector('[data-rival-details-clear]'), 'remove');
  }
  function mount() {
    document.querySelectorAll('[data-rival-vehicle-finder]').forEach(root => {
      enhance(root);
      if (observed.has(root)) return;
      observed.add(root);
      const observer = new MutationObserver(mutations => {
        const relevant = mutations.some(mutation => mutation.target instanceof Element && mutation.target.closest('.rival-vehicle-identity, [data-rival-garage-list]'));
        if (!relevant) return;
        observer.disconnect();
        enhance(root);
        observe();
      });
      function observe() {
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-has-plate'] });
      }
      observe();
    });
  }
  mount();
  for (const event of ['DOMContentLoaded', 'rival:finder-ready', 'shopify:section:load']) document.addEventListener(event, mount);
})();
/* END RIVAL: manual selection badges and consistent vehicle action controls. */
